<template>
  <div>
    <div class="text">
      <div class="d-flex flex-column align-center">
        <blockquote>
          <br>A la demande de la <strong>DREAL Grand Est</strong>
          <br>nous effectuons une enquête
          <br>sur le ressenti par les habitants de VARANGEVILLE
          <br>des tirs de mines
          <br>ainsi que des vibrations accompagnant ces tirs.
          <p></p>
          <br><strong>Recensez votre ressenti de tir:</strong>
          <p></p>
        </blockquote>
      </div>
    </div>
    <div class="form">
      <v-form ref="form" v-model="valid">
        <v-text-field v-model="name" label="Nom" required :rules="nameRules"></v-text-field>
        <v-text-field v-model="address" label="Adresse" required :rules="nameRules"></v-text-field>

        <v-select
          :items="towns"
          item-title="town_name"
          item-value="town_name"
          v-model="town"
          label="Ville"
          outlined
          return-object
          persistent-hint
          :rules="nameRules"
        ></v-select>

        <v-col>
          <v-text-field v-model="date" label="Date" type="date" prepend-icon="mdi-calendar" :rules="nameRules"></v-text-field>
        </v-col>

        <v-col>
          <v-text-field v-model="time" label="Heure" type="time" prepend-icon="mdi-clock" :rules="nameRules"></v-text-field>
        </v-col>

        <v-col>
          <v-card-text>
            Intensité du tir
            <v-rating
              v-model="intensity"
              color="yellow-darken-3"
              bg-color="grey-darken-1"
              hover
              size="36"
            ></v-rating>
          </v-card-text>
        </v-col>

        <v-col>
          <v-btn :disabled="!valid" color="success" @click="validate">Ajouter</v-btn>
        </v-col>

        <div v-if="errors.length">
          <b>Erreur:</b>
          <ul>
            <li v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </div>
        <div v-if="status !== null">
          <b>{{ status }}</b>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      valid: true,
      date: new Date().toISOString().substr(0, 10),
      time: null,
      name: null,
      address: null,
      town: null,
      intensity: null,
      errors: [],
      status: null,
      towns: [
        { town_name: 'Art-sur-Meurthe', postal_code: 54510 },
        { town_name: 'Dombasle-sur-Meurthe', postal_code: 54110 },
        { town_name: 'Lenoncourt', postal_code: 54110 },
        { town_name: 'Rosières-aux-Salines', postal_code: 54110 },
        { town_name: 'Saint-Nicolas-de-Port', postal_code: 54210 },
        { town_name: 'Varangéville', postal_code: 54110 },
        { town_name: 'Ville-en-Vermois', postal_code: 54571 },
      ],
      nameRules: [v => !!v || 'required'],
    }
  },
  methods: {
    validate () {
      this.$refs.form.validate().then(valid => {
        if (!valid) return
        this.errors = []
        this.status = null
        var errs = this.errors
        this.$apiclient.addTir(
          this.name, this.address,
          this.town.postal_code, this.town.town_name,
          this.date + ' ' + this.time + ':00',
          parseInt(this.intensity)
        )
          .then(response => {
            if (response.status !== 200) errs.push(response.statusText)
            this.status = 'Votre tir a été recensé! Merci'
            this.valid = false
          })
          .catch(error => { errs.push(error.response.statusText) })
      })
    }
  }
}
</script>
